import {
  FINANCIAL_RECORD_AMOUNT_FORM_FIELDS,
  FINANCIAL_RECORD_PAYMENT_INFO_FIELDS, FinancialRecordAmountFormConfig,
  FinancialRecordAmountListConfig,
  FinancialRecordDetailsConfig,
  FinancialRecordPaymentInfoConfig
} from "@celerofinancas/ui-cash-flow";
import { MoneyPipeConfig } from "@celerofinancas/ui-pipes/";

export const MONEY_PIPE_CONFIG_DEFAULT: MoneyPipeConfig = {
  prefix: '',
  thousand: '.',
  decimalSeparator: ',',
  showNegative: false,
  displayThousands: true,
  showIndicator: true,
}

export const FINANCIAL_RECORD_DETAILS_CONFIGS_DEFAULT: FinancialRecordDetailsConfig = {
  showEconomicGroupName: false,
  showCreateAtTitle: false,
  showPaymentInfoTitle: true,
  showPreviousAmountValue: false,
  showAmountsTitleTooltip: false,
  showHiddenAmountsButton: false,
  showDocumentsSection: false,
  showCommentsSection: false,
  showHistorySection: true,
  showGotoHistoryButton: false,
  showRecordNameAutoComplete: false,
  showCopyLinkButton: false,
  statusIconPosition: 'header',
  showAmountCount: false,
  recordNameFn: (r: {
    name?: string;
    bank_id?: string;
    amounts?: { company_related?: { name?: string } | null }[];
  }) =>
    r.bank_id === '104' && r.amounts?.[0]?.company_related?.name
      ? `${r.name} - ${r.amounts[0].company_related.name}`
      : r.name,
  allowRecordNameEdit: false,
  nameMaxLines: 2,
}

export const FINANCIAL_RECORD_AMOUNT_LIST_DEFAULT_CONFIGS_DEFAULT: FinancialRecordAmountListConfig = {
  showSelectCheckbox: false,
  showUploadButtons: false,
}

export const FINANCIAL_RECORD_PAYMENT_INFO_DEFAULT_CONFIGS_DEFAULT: FinancialRecordPaymentInfoConfig = {
  fields: [
    [
      {
        key: FINANCIAL_RECORD_PAYMENT_INFO_FIELDS.DUE_AT,
        order: 1,
        editable: false,
        label: 'Vencimento',
        showTooltip: false,
      },
      {
        key: FINANCIAL_RECORD_PAYMENT_INFO_FIELDS.PAID_AT,
        order: 2,
        editable: false,
        label: 'Liquidado em',
        showTooltip: false,
      },
    ],
    [
      {
        key: FINANCIAL_RECORD_PAYMENT_INFO_FIELDS.PAYMENT_METHOD,
        order: 1,
        editable: false,
        label: 'Método de pagamento',
      },
      {
        key: FINANCIAL_RECORD_PAYMENT_INFO_FIELDS.CHECKING_ACCOUNT,
        order: 2,
        editable: false,
        label: 'Conta',
        verifyTypeDocument: true,
      },
    ],
  ],
}

export const FINANCIAL_RECORD_AMOUNT_FORM_DEFAULT_CONFIGS_DEFAULT: FinancialRecordAmountFormConfig = {
  showViewMoreAmountInfo: false,
  showAmountTitle: false,
  showApplyToAllCheckbox: false,
  fields: [
    {
      key: FINANCIAL_RECORD_AMOUNT_FORM_FIELDS.AMOUNT,
      editable: false,
      label: 'Valor do lançamento',
      order: 1,
      required: false,
    },
    {
      key: FINANCIAL_RECORD_AMOUNT_FORM_FIELDS.CLASSIFICATION,
      editable: true,
      label: 'Categoria',
      order: 2,
      required: false,
    },
    {
      key: FINANCIAL_RECORD_AMOUNT_FORM_FIELDS.DESCRIPTION,
      editable: true,
      label: 'Nome do lançamento',
      order: 3,
      required: true,
    },
    {
      key: FINANCIAL_RECORD_AMOUNT_FORM_FIELDS.COST_CENTER,
      editable: true,
      label: 'Centro de custos',
      order: 4,
      required: true,
    },
    {
      key: FINANCIAL_RECORD_AMOUNT_FORM_FIELDS.ACCRUAL_BASIS,
      editable: true,
      label: 'Período de competência',
      order: 5,
      required: true,
    },
    {
      key: FINANCIAL_RECORD_AMOUNT_FORM_FIELDS.OBSERVATION,
      editable: true,
      label: 'Observações',
      labelNote: 'Opcional',
      order: 6,
      required: false,
    },
  ],
}
